import { LeadTypeEnum } from "enums/lead-type.enum";

export const ALTO_SUPPORTED_LEAD_TYPES = [
  LeadTypeEnum.Sale,
  LeadTypeEnum.Let,
  LeadTypeEnum.Vendor,
  LeadTypeEnum.Landlord,
];
